export default __webpack_public_path__ + "static/media/goal-3.fbc70dcf.svg";